import * as React from 'react';
import FormControlUnstyledContext from './FormControlUnstyledContext';
export default function useFormControlUnstyledContext() {
  return React.useContext(FormControlUnstyledContext);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/base/FormControlUnstyled/useFormControlUnstyledContext.js
// module id = 915
// module chunks = 1